module.exports = __webpack_public_path__ + "img/Plataforma_de_assinatura.af0b94b.svg";